/**
 * partnerTransfer.js — передача карточки партнёра другому менеджеру.
 *
 * Вынесено из partnerCrm.js: тот упёрся в baseline размера файла (гейт
 * check_component_size), а передача владельца — самостоятельная область со
 * своими правилами: причина попадает в журнал, открытые задачи прежнего
 * владельца переезжают, история читается тем же скоупом, что и карточка.
 */
import { apiFetch } from './core'

const BASE = '/partner-crm'

export const partnerTransfer = {
    // Отличается от смены менеджера через patchPartner: фиксирует причину,
    // переносит открытые задачи и уведомляет обе стороны.
    transfer: (id, { managerId, reason = '', moveOpenTasks = true }) =>
        apiFetch(`${BASE}/partners/${id}/transfer`, {
            method: 'POST',
            body: JSON.stringify({
                manager_id: managerId,
                reason: reason?.trim() ? reason.trim() : null,
                move_open_tasks: moveOpenTasks,
            }),
        }),
    // Кому можно передать: отдельный эндпоинт вместо общего списка юзеров —
    // тот рядовому менеджеру отвечает 403, и выпадающий список оставался пустым.
    eligibleManagers: () => apiFetch(`${BASE}/eligible-managers`),
    history: (id, limit = 50) => apiFetch(`${BASE}/partners/${id}/manager-history?limit=${limit}`),
}
